module.exports = __webpack_public_path__ + "static/peering-ff915d394cb292042fdf2b2578f7228b.svg";